import { BehaviorSubject } from 'rxjs';

function parseJwt(token) {
    if (!token) {
        return null;
    }

    try {
        const payload = token.split('.')[1];
        if (!payload) {
            return null;
        }

        return JSON.parse(window.atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    } catch (error) {
        return null;
    }
}

function getStoredCurrentUser() {
    try {
        const rawUser = localStorage.getItem('currentUser');
        if (!rawUser) {
            return null;
        }

        const parsedUser = JSON.parse(rawUser);
        const decodedToken = parseJwt(parsedUser && parsedUser.refreshToken);
        const tokenUserId = decodedToken && decodedToken.id;

        if (!parsedUser || !parsedUser.refreshToken || !tokenUserId || tokenUserId === '?' || tokenUserId === 'undefined' || tokenUserId === 'null') {
            localStorage.removeItem('currentUser');
            return null;
        }

        return parsedUser;
    } catch (error) {
        localStorage.removeItem('currentUser');
        return null;
    }
}

const currentUserSubject = new BehaviorSubject(getStoredCurrentUser());

export const authenticationService = {
    login,
    logout,
    authVerify,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value }
};

function login(username, password, keepMeLogged, logIP, latIP, lngIP) {
    const requestOptions = {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
            username: username,
            password: password,
            keepMeLogged: keepMeLogged,
            logIP: logIP, latIP: "" + latIP, lngIP: "" + lngIP
        })
    };
    return fetch(`/api/Authentication/authenticate`, requestOptions)
        .then(response => response.json())
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            if (user.id != null) {
                localStorage.setItem('currentUser', JSON.stringify(user));
                currentUserSubject.next(user);   
            }
            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    return fetch(`/api/Account/Logout`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then(response => response.json()).then(res => {
            if (res.successState) {
                //localStorage.setItem("lamcouser", JSON.stringify(res));
                //currentUserSubject.next(res);
                //gotoSuccessLogin(res.redirect);
            }
            localStorage.removeItem('currentUser');
            currentUserSubject.next(null);
            return res.successState;
        });    
}
function authVerify() {
    return fetch(`/api/Authentication/CheckAuthentication`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then(response => response.json()).then(res => {
            if (!res.status) {
                localStorage.removeItem('currentUser');
                currentUserSubject.next(null);
            }
            return res.status;
        });
    //const user = JSON.parse(localStorage.getItem("currentUser"));
    //if (user) {
    //    const decodedJwt = parseJwt(user.refreshToken);
    //    if (decodedJwt.expires * 1000 < Date.now()) {
    //        logout();
    //    }
    //}
}